<template>
  <div>
    <ExtinguisherTabs>
      <template #item>
        <Transition mode="out-in">
          <Form :description-title="'Atualize a ficha cadastral deste item'">
            <CreateButton
              @click="updateItem()"
              :icon="PhArrowsClockwise"
              :label="'Atualizar'"
            />
          </Form>
        </Transition>
      </template>

      <template #maintenance>
        <div>
          <Transition mode="out-in">
            <component
              :is="currentComponent || Component"
              :dataTable="store.itensForm?.maintenances"
              :formCreate="formType"
            />
          </Transition>
        </div>

        <FloatButton
          v-if="!setButton"
          @click.prevent="changeComponent(RegisterMaintenance)"
          :title="'Registrar manutenção'"
        />

        <FloatBackToComponent
          v-else
          @click.prevent="changeComponent(MaintenanceList)"
        />
      </template>
    </ExtinguisherTabs>
  </div>
</template>

<script setup>
import FloatBackToComponent from '../../components/_partials/FloatBackToComponent.vue'
import ExtinguisherTabs from '../../components/_partials/ExtinguisherTabs.vue'
import FloatButton from '../../components/_partials/FloatShowComponent.vue'
import RegisterMaintenance from '../maintenance/RegisterMaintenance.vue'
import ExtinguisherService from '../../service/event.service'
import MaintenanceList from '../maintenance/MaintenanceList.vue'
import CreateButton from '@/components/Buttons/Create.vue'
import Form from '../../components/RegisterItensForm.vue'
import { showToast as toast } from '@/helpers/UseToasts'
import { PhArrowsClockwise } from '@phosphor-icons/vue'
import { dataExtinguisher } from '../../store'
import { storeApp } from '@/store'
import * as yup from '@/validator'
import { ref, markRaw } from 'vue'
import {
  cleanAllFormFields,
  setFormFieldsError,
  validateFormField
} from '@/helpers/formFieldsHandler'

const store = dataExtinguisher.state
const appStore = storeApp.state

const formType = ref({})
const setButton = ref(false)
const currentComponent = ref(markRaw(MaintenanceList))

const changeComponent = (componentName) => {
  formType.value = {
    create: true,
    labelButton: 'Adicionar',
    descriptionTitle: 'Registrar uma nova manutenção'
  }
  // store.commit('reset')
  setButton.value = !setButton.value
  currentComponent.value = markRaw(componentName)
}

const schema = yup.object().shape({
  itensForm: yup.object().shape({
    name: yup.string().required('Informe o nome do item').label('Item'),
    type: yup.lazy(value => {
      switch (typeof value) {
        case 'object':
          return yup.object().required('Informe o tipo do item').label('Tipo')
        case 'string':
          return yup.string().required('Informe o tipo do item').label('Item')
      }
    })
  })
})

async function updateItem () {
  appStore.loading = true

  cleanAllFormFields()
  const validate = await validateFormField(schema, store)
  if (validate && validate.length > 0) {
    setFormFieldsError(validate)
    appStore.loading = false
    return
  }

  // fluxo da imagem
  if (
    store.itensForm.oldImage !== null &&
    store.itensForm.oldImage !== '[]' &&
    typeof store.itensForm.images === 'object' &&
    typeof store.itensForm.imagesName === 'string'
  ) {
    await ExtinguisherService.editImage(
      store.itensForm.images,
      store.itensForm.oldImage
    )
      .then((res) => {
        store.itensForm.imagesName = res.data
        store.itensForm.images = res.data
        store.itensForm.oldImage = res.data
      })
      .catch((err) => toast('Aviso', 'Imagem não foi salva', 'error'))
  } else if (
    store.itensForm.oldImage == null ||
    store.itensForm.oldImage == '[]' &&
    typeof store.itensForm.images === 'object' &&
    typeof store.itensForm.imagesName === 'string'
  ) {
    await ExtinguisherService.saveImage(store.itensForm.images)
      .then((res) => {
        store.itensForm.imagesName = res.data
        store.itensForm.images = res.data
        store.itensForm.oldImage = res.data
      })
      .catch((err) => toast('Aviso', 'Imagem não foi salva', 'error'))
  }

  const data = store.itensForm

  if (typeof data.type === 'object') { data.type = data.type.name }

  delete data?.maintenances
  delete data?.imagesName
  delete data?.oldImage

  await ExtinguisherService.editItem(store.itensForm.id, data)
    .then((res) => {
      appStore.loading = false

      if (res?.data?.success) {
        // atualiza a listagem dos itens
        Promise.allSettled([
          ExtinguisherService.allExtinguishersBySector(store.sectorId)
            .then((res) => {
              if (res?.data[0]) {
                dataExtinguisher.dispatch(
                  'setItemsBySector',
                  res?.data[0]?.itens
                )
              }
            })
            .catch((err) => {
              storeApp.state.loading = false

              if (
                err?.response?.data?.error &&
                err.response.data.status === 400
              ) {
                return toast('Aviso', err.response.data.message, 'error')
              }

              return toast(
                'Aviso',
                'Algo deu errado ao remover setor',
                'error'
              )
            })
        ])

        return toast('Sucesso', res.data.message, 'success')
      }
    })
    .catch((err) => {
      appStore.loading = false

      if (err?.response?.data?.error) {
        return toast('Aviso', err.response.data.message, 'error')
      }

      return toast('Aviso', 'Algo deu errado ao atualizar item', 'error')
    })
}
</script>

<style lang="scss" scoped>
.v-enter-from,
.v-leave-to {
  transform: translate(50px);
  opacity: 0;
}

.v-enter-active,
.v-leave-active {
  transition: all 0.3s;
}
</style>
